import { type Component, type Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import { idField } from 'utils/builder/fields';

const partnerCardFields = [
  idField,
  imageField(),
  {
    name: 'name',
    type: 'string',
    helperText: 'Partner name shown under the logo.',
    required: true,
  },
  {
    name: 'summary',
    type: 'string',
    helperText: 'Short description for the partner card.',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    helperText: 'Configure label + link for the “Learn more” button.',
  },
] as const satisfies DeepReadonly<Input[]>;

const featuredPartnersFields = [
  ...sectionFields,
  {
    name: 'heading',
    type: 'string',
    helperText: 'Heading displayed at the top of the Featured Partners section.',
    defaultValue: 'Featured Partners',
  },
  {
    name: 'partners',
    type: 'list',
    subFields: partnerCardFields,
    helperText: 'Add as many partner cards as you want.',
  },
] as const satisfies DeepReadonly<Input[]>;

const featuredPartnersConfig = {
  name: 'featuredPartnersCards',
  inputs: featuredPartnersFields,
} as Component;

export type PartnerCardConfig = GenerateBuilder<typeof partnerCardFields>;
export type FeaturedPartnersConfig = GenerateBuilder<typeof featuredPartnersFields>;

export default featuredPartnersConfig;
